export const CHECKOUT_URL = 'https://olympic-weightlifting-coach-ready.impultienda.ar/checkout'

export const PRICE_LABEL = '$26.90 USD'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/xosBoxfRJW5NKoWAhYB1D9/Diseno_sin_titulo_(65).png'

export interface IncludedItem {
  label: string
  kind: 'included' | 'bonus'
}

export interface IncludedGroup {
  label: string
  items: IncludedItem[]
}

export const packageGroups: IncludedGroup[] = [
  {
    label: 'You receive:',
    items: [
      { kind: 'included', label: 'System 1 — Olympic Weightlifting Foundations & Coaching Essentials' },
      { kind: 'included', label: 'System 2 — Snatch Technique, Progressions & Error Correction' },
      { kind: 'included', label: 'System 3 — Clean & Jerk Technique, Progressions & Error Correction' },
      { kind: 'included', label: 'System 4 — Strength, Mobility & Weightlifting-Specific Development' },
      { kind: 'included', label: 'System 5 — Athlete Assessment, Programming & Performance Development' },
      { kind: 'included', label: 'System 6 — 150 Ready-to-Coach Olympic Weightlifting Sessions' },
    ],
  },
  {
    label: 'Plus:',
    items: [
      { kind: 'bonus', label: '100 Common Olympic Weightlifting Errors & Coach Corrections' },
      { kind: 'bonus', label: 'Olympic Weightlifting Warm-Up & Mobility Library' },
      { kind: 'bonus', label: 'Weightlifting Coaching Cues & Technical Checklist Handbook' },
      { kind: 'bonus', label: 'Olympic Weightlifting Athlete Testing & Progress Tracking System' },
      { kind: 'bonus', label: '50 Olympic Weightlifting Drills for Technique Correction' },
    ],
  },
  {
    label: 'And throughout the complete system:',
    items: [
      { kind: 'included', label: 'Visual Technique Breakdowns' },
      { kind: 'included', label: 'Step-by-Step Lift Sequences' },
      { kind: 'included', label: 'Bar-Path Diagrams' },
      { kind: 'included', label: 'Correct vs Incorrect Comparisons' },
      { kind: 'included', label: 'Technical Position Maps' },
      { kind: 'included', label: 'Drill Progressions' },
      { kind: 'included', label: 'Coaching Cues' },
      { kind: 'included', label: 'Visual Checklists' },
      { kind: 'included', label: 'Assessment Tools' },
      { kind: 'included', label: 'Quick-Reference Cards' },
      { kind: 'included', label: 'Immediate Digital Access' },
      { kind: 'included', label: 'PDF Format' },
    ],
  },
]

export const finalIncludedItems: IncludedItem[] = [
  { kind: 'included', label: '6 Complete Visual Coaching Systems' },
  { kind: 'included', label: '150 Ready-to-Coach Olympic Weightlifting Sessions' },
  { kind: 'included', label: 'Visual Snatch Progressions' },
  { kind: 'included', label: 'Visual Clean & Jerk Progressions' },
  { kind: 'included', label: 'Bar-Path Diagrams' },
  { kind: 'included', label: 'Correct vs Incorrect Technique Comparisons' },
  { kind: 'included', label: 'Technical Error-Correction Systems' },
  { kind: 'included', label: 'Visual Drill Progressions' },
  { kind: 'included', label: 'Strength & Mobility Development' },
  { kind: 'included', label: 'Athlete Assessment' },
  { kind: 'included', label: 'Programming & Performance Development' },
  { kind: 'included', label: 'Professional Coaching Tools' },
  { kind: 'bonus', label: '5 Professional Visual Bonus Guides' },
  { kind: 'included', label: 'Immediate Digital Access' },
  { kind: 'included', label: 'PDF Format' },
]
